<template>
  <iframe
    title="Paylands"
    class="payment"
    :src="redirectUrl"
  >
  </iframe>
</template>

<script>
import { mapState } from 'vuex'
import routeNames from '@/router/routes'
import reservationMixins from '@/mixins/Reservation'
import { ActivityReservationsRequests } from '@/services/activityReservations.requests'
import { activityReservationStatus } from '@/config'
import { PAYMENT_ATTEMPTS } from '@/config/environment'

const activityReservationsService = new ActivityReservationsRequests()

export default {
  name: 'Payment',
  
  mixins: [
    reservationMixins,
  ],

  data () {
    return  {
      reservationStatusVerificationAttempts: 0,
      checkStatusTimeoutId: null,
    }
  },

  computed: {
    ...mapState(['activityReservations', 'state', 'pages']),

    redirectUrl () {
      return this.$route.params.redirectUrl
    },

    hasRedirectUrl () {
      return !!this.redirectUrl
    },
  },

  methods: {
    checkStatus (event) {
      if (event && event.data && event.data.status) {
        if (event.data.status === 'ok') {
          this.checkStatusReservation()
        } else if (event.data.status === 'ko') {
          const body = {
            errors: [
              {
                name: 'failed_payment',
                value: true,
              },
            ],
          }

          const params = {
            activityReservationId: this.activityReservations.lastReservation ? this.activityReservations.lastReservation : this.$route.params.activityReservationId,
            paymentServiceId: this.activityReservations.edited.paymentServiceId ? this.activityReservations.edited.paymentServiceId : this.$route.params.paymentServiceId,
            pageId: this.pages.page.id,
          }

          this.$store.commit('state/setError', { body })

          this.$router.replace({ name: routeNames.reservationError.name, params: { reservationMethod: this.reservationMethod, ...params }  })
        }
      }
    },

    async checkStatusReservation () {
      const activityReservationId = this.activityReservations.lastReservation ? this.activityReservations.lastReservation : this.$route.params.activityReservationId
      await activityReservationsService
        .getReservation(activityReservationId)
        .then((response) => {
          this.reservationStatusVerificationAttempts++

          if (response.reservation.status === activityReservationStatus.ACCEPTED) {
            if (this.checkStatusTimeoutId) {
              clearTimeout(this.checkStatusTimeoutId)
            }
 
            const params = {
              activityReservationId: this.activityReservations.lastReservation ? this.activityReservations.lastReservation : this.$route.params.activityReservationId,
              status: activityReservationStatus.SUCCESS_PAYMENT,
              pageId: this.pages.page.id,
            }

            this.$router.push({ name: routeNames.reservationComplete.name, params })
          } else {
            if (this.reservationStatusVerificationAttempts < PAYMENT_ATTEMPTS) {
              this.checkStatusTimeoutId = setTimeout(this.checkStatusReservation, 3000)
            } else {
              const params = {
                activityReservationId: this.activityReservations.lastReservation ? this.activityReservations.lastReservation : this.$route.params.activityReservationId,
                status: activityReservationStatus.PROCESSING_PAYMENT,
                pageId: this.pages.page.id,
              }

              this.$router.push({ name: routeNames.reservationComplete.name, params })
            }
          }
        })
    },

    comeBack () {
      this.$router.go(-1)
    },
  },

  created () {
    if (!this.hasRedirectUrl) {
      this.comeBack()
    } else {
      window.addEventListener('message', this.checkStatus, false)
    }
  },
  beforeDestroy () {
    if (this.hasRedirectUrl) {
      window.removeEventListener('message', this.checkStatus, false)
    }
  },
}
</script>

<style>
.payment {
  max-width: 600px;
  width: 100%;
  height: 100%;
}

iframe {
  border: none;
}
</style>
